import React, { useEffect } from "react";
import HelmetLayout from "../components/HelmetLayout/HelmetLayout";

import "../components/Styles/CookieTermsPrivacy.css";

const CookiePolicy = () => {
  useEffect(() => {
    (function (d, s, id) {
      var js,
        tjs = d.getElementsByTagName(s)[0];
      // if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      tjs.parentNode.insertBefore(js, tjs);
    })(document, "script", "termly-jssdk");
  }, []);
  return (
    <div className="container">
      <HelmetLayout
        titleProps={`Cookie Policy | Swifty Global`}
        children={
          <>
            <meta
              property="og:title"
              content="Cookie Policy | Swifty Global"
              data-react-helmet="true"
            />
            <meta
              property="og:type"
              content="website"
              data-react-helmet="true"
            />
            <meta
              property="og:url"
              content="https://www.swifty.global/cookiepolicy"
              data-react-helmet="true"
            />
          </>
        }
      />
      <div className="center-container">
        <div
          name="termly-embed"
          data-id="d03e6126-c743-41a7-93e5-369f53468a44"
          data-type="iframe"
        ></div>
      </div>

      {/* <CookieComponent /> */}
    </div>
  );
};

export default CookiePolicy;
